import axios from "axios";
import { authStore } from "../context/authContext/authStore";

export const BASE_URL = process.env.REACT_APP_API;
export const SECOND_URL = process.env.REACT_APP_SECOND_API;
export const CLIENT = process.env.REACT_APP_CLIENT_NAME;
//
export default axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

const secondAxios = axios.create({
  baseURL: SECOND_URL,
  withCredentials: true,
});

////////////////////////////// Request
secondAxios.interceptors.request.use((config) => {
  const token = authStore.getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
    // config.headers["X-Client"] = CLIENT;
  }
  return config;
});

//////////////////////////// Response
secondAxios.interceptors.response.use(
  (res) => res,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers["Authorization"] = "Bearer " + token;
            return secondAxios(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const { data } = await secondAxios.post("/auth/refresh");
        authStore.setToken(data.accessToken); // update global store
        processQueue(null, data.accessToken);

        originalRequest.headers["Authorization"] = "Bearer " + data.accessToken;
        return secondAxios(originalRequest);
      } catch (err) {
        processQueue(err, null);
        authStore.clear();
        // window.location.href = "/login";
        return Promise.reject(err);
      } finally {
        isRefreshing = false;
        // window.location.href = "/login"; // redirect
      }
    }

    return Promise.reject(error);
  }
);

export { secondAxios };
